/** MarryGo brand mark (gold app icon) — served from public/ */
const publicUrl = process.env.PUBLIC_URL || '';

export const APP_LOGO_SRC = `${publicUrl}/logo192.png`;
export const APP_LOGO_ALT = 'MarryGo';
